import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ModelPjType} from "app/dar/common/services/model-pj/model-pj.model";

@Component({
  selector: 'app-model-pj-type-edit',
  templateUrl: './model-pj-type-edit.component.html',
  styleUrls: ['./model-pj-type-edit.component.scss']
})
export class ModelPjTypeEditComponent implements OnInit {
  modelPjTypeForm: UntypedFormGroup;

  constructor(
    @Optional() public dialogRef: MatDialogRef<ModelPjTypeEditComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ModelPjType,
    private formBuilder: UntypedFormBuilder,
  ) {
  }

  ngOnInit(): void {
    this._initForm();
    this._initFormValues();
  }

  onSubmit() {
    this.dialogRef.close(this.modelPjTypeForm.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private _initForm(): void {
    this.modelPjTypeForm = this.formBuilder.group({
      id: ['', []],
      name: ['', [Validators.required, Validators.minLength(3)]],
      description: ['', []]
    });
  }

  private _initFormValues(): void {
    this.modelPjTypeForm.setValue({
      id: this.data?.id ?? 0,
      name: this.data?.name ?? '',
      description: this.data?.description ?? ''
    });
  }
}
